import { Center } from '@euler/components/Center';
import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, useCallback } from 'react';
import { StyleProp, ViewStyle } from 'react-native';

export const Checkbox = memo(
  ({
    checked,
    style,
    shape = 'default',
    uncheckedColor = '#777',
    checkedColor = '#207FE7',
    size,
    onChange,
    onPress: onPress_,
  }: {
    checked?: boolean;
    style?: StyleProp<ViewStyle>;
    size?: number;
    shape?: 'default' | 'circle';
    checkedColor?: string;
    uncheckedColor?: string;
    onChange?: (checked: boolean) => void;
    onPress?: () => void;
  }) => {
    const { rpx } = useResponsiveContext();

    const onPress = useCallback(() => {
      onPress_?.();
      onChange?.(!checked);
    }, [checked, onChange, onPress_]);

    return (
      <Center.Touchable style={style} onPress={onPress}>
        <Icon
          name={
            checked
              ? shape === 'circle'
                ? 'checkmark-circle'
                : 'checkbox'
              : shape === 'circle'
              ? 'radio_button_off'
              : 'checkbox_outline'
          }
          color={checked ? checkedColor : uncheckedColor}
          size={size ?? rpx(16)}
        />
      </Center.Touchable>
    );
  },
);
